import React from 'react';
import PropTypes from 'prop-types';

import {
  Wrap
} from './styled';

const Container = ({ options }) => (
  <Wrap
    id={options.containerId}
    position={options.position}
    type={options.type}
    colors={options.colors} />
)

Container.propTypes = {
  options: PropTypes.object,
}

export default Container;


// WEBPACK FOOTER //
// ./client/components/Toast/Container/index.js